/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { IndividualPaymentPersonViewModel } from "../types/IndividualPaymentPersonViewModel.ts";

export const individualPaymentPersonViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  name: z.string().nullish(),
}) as unknown as ToZod<IndividualPaymentPersonViewModel>;
